// extracted by mini-css-extract-plugin
module.exports = {"globalThreeWSankey":"styles_globalThreeWSankey__mzSyA","sankeyLink":"styles_sankeyLink__FZGrN","sankeyLinkLeft":"styles_sankeyLinkLeft__1AumC"};